/**
 * @generated SignedSource<<58b0c1967920da57b0c71b2f17eb176c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SwapAmountFor = "SOURCE" | "TARGET";
export type CreateSwapOfferInput = {
  amount: string;
  amountDefinedFor: SwapAmountFor;
  sourceAssetId: string;
  targetAssetId: string;
};
export type CreateSwapOfferMutation$variables = {
  input?: CreateSwapOfferInput | null | undefined;
};
export type CreateSwapOfferMutation$data = {
  readonly createSwapOffer: {
    readonly __typename: "SwapOffer";
    readonly assetNetConversionRate: PrecisionFloat | null | undefined;
    readonly expiresAt: TimeScalar | null | undefined;
    readonly feeAmount: PrecisionFloat | null | undefined;
    readonly id: string;
    readonly sourceAmount: PrecisionFloat;
    readonly sourceAsset: {
      readonly __typename: string;
      readonly id: string;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly price: PrecisionFloat | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly targetAmount: PrecisionFloat;
    readonly targetAsset: {
      readonly __typename: string;
      readonly id: string;
      readonly legalUrl: string | null | undefined;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly price: PrecisionFloat | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly taxAmount: PrecisionFloat;
  } | null | undefined;
};
export type CreateSwapOfferMutation = {
  response: CreateSwapOfferMutation$data;
  variables: CreateSwapOfferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SwapOffer",
    "kind": "LinkedField",
    "name": "createSwapOffer",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sourceAsset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "targetAsset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "legalUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetNetConversionRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feeAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxAmount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSwapOfferMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSwapOfferMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "c8f9794ebb3e707bef81bc1f27fc5be0",
    "id": null,
    "metadata": {},
    "name": "CreateSwapOfferMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSwapOfferMutation(\n  $input: CreateSwapOfferInput\n) {\n  createSwapOffer(input: $input) {\n    id\n    __typename\n    expiresAt\n    sourceAsset {\n      __typename\n      id\n      name\n      price\n      logoUrl\n      symbol\n    }\n    targetAsset {\n      __typename\n      id\n      name\n      price\n      logoUrl\n      symbol\n      legalUrl\n    }\n    sourceAmount\n    targetAmount\n    assetNetConversionRate\n    feeAmount\n    taxAmount\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a5d4d896a596b85291882f6781a5499";

export default node;
